var _path, _g, _g2, _g3, _g4, _g5, _g6, _rect, _path2, _path3, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 451,
    viewBox: "0 0 532 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258 451C372.875 451 466 357.875 466 243C466 128.125 372.875 35 258 35C143.125 35 50 128.125 50 243C50 357.875 143.125 451 258 451ZM258 346.999C315.437 346.999 362 300.436 362 242.999C362 185.561 315.437 138.999 258 138.999C200.562 138.999 154 185.561 154 242.999C154 300.436 200.562 346.999 258 346.999Z",
    fill: "#EEEFF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379,
    y: 153,
    width: 34,
    height: 34,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.708,
    y: 153.708,
    width: 32.5833,
    height: 32.5833,
    stroke: "#009D81",
    strokeWidth: 1.41667,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.917,
    y: 162.917,
    width: 14.1667,
    height: 14.1667,
    rx: 7.08333,
    fill: "#009D81"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 336,
    width: 16,
    height: 16,
    rx: 2,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.333,
    y: 336.333,
    width: 15.3333,
    height: 15.3333,
    rx: 1.66667,
    stroke: "#009D81",
    strokeWidth: 0.666667,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.667,
    y: 340.667,
    width: 6.66667,
    height: 6.66667,
    rx: 3.33333,
    fill: "#009D81"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 328,
    width: 32,
    height: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.667,
    y: 328.667,
    width: 30.6667,
    height: 30.6667,
    stroke: "#009D81",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.333,
    y: 337.333,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    fill: "#009D81"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 132,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.833,
    y: 132.833,
    width: 38.3333,
    height: 38.3333,
    rx: 19.1667,
    stroke: "#009D81",
    strokeWidth: 1.66667,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.667,
    y: 143.667,
    width: 16.6667,
    height: 16.6667,
    rx: 8.33333,
    fill: "#009D81"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 37,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.039 53.777C168.413 53.8772 168.635 54.2618 168.535 54.6359L164.819 68.5027C164.719 68.8768 164.334 69.0988 163.96 68.9985C163.586 68.8983 163.364 68.5138 163.464 68.1396L167.18 54.2729C167.28 53.8988 167.665 53.6768 168.039 53.777Z",
    fill: "#009D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.154 56.6311C170.413 56.3432 170.856 56.3199 171.144 56.579L172.769 58.0412C173.457 58.6608 174.028 59.1748 174.42 59.641C174.833 60.1312 175.126 60.6579 175.126 61.308C175.126 61.9582 174.833 62.4849 174.42 62.9751C174.028 63.4413 173.457 63.9553 172.769 64.5749L171.144 66.0371C170.856 66.2962 170.413 66.2729 170.154 65.985C169.894 65.6971 169.918 65.2537 170.206 64.9946L171.792 63.5669C172.529 62.9038 173.025 62.4546 173.347 62.0722C173.656 61.7051 173.723 61.4908 173.723 61.308C173.723 61.1253 173.656 60.911 173.347 60.5439C173.025 60.1614 172.529 59.7122 171.792 59.0492L170.206 57.6215C169.918 57.3624 169.894 56.919 170.154 56.6311Z",
    fill: "#009D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.793 57.6215C162.081 57.3624 162.105 56.919 161.846 56.6311C161.586 56.3432 161.143 56.3199 160.855 56.579L159.23 58.0412C158.542 58.6608 157.971 59.1748 157.579 59.641C157.166 60.1312 156.873 60.6579 156.873 61.308C156.873 61.9582 157.166 62.4849 157.579 62.9751C157.971 63.4413 158.542 63.9553 159.23 64.5749L160.855 66.0371C161.143 66.2962 161.586 66.2729 161.846 65.985C162.105 65.6971 162.081 65.2537 161.793 64.9946L160.207 63.5669C159.47 62.9038 158.974 62.4546 158.652 62.0722C158.343 61.7051 158.276 61.4908 158.276 61.308C158.276 61.1253 158.343 60.911 158.652 60.5439C158.974 60.1614 159.47 59.7122 160.207 59.0492L161.793 57.6215Z",
    fill: "#009D81"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 35,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.515 59.5153C360.944 62.0862 360.944 66.2241 360.944 74.4999C360.944 82.7757 360.944 86.9135 363.515 89.4845C366.086 92.0554 370.224 92.0554 378.5 92.0554C386.776 92.0554 390.914 92.0554 393.484 89.4845C396.055 86.9135 396.055 82.7757 396.055 74.4999C396.055 66.2241 396.055 62.0862 393.484 59.5153C390.914 56.9443 386.776 56.9443 378.5 56.9443C370.224 56.9443 366.086 56.9443 363.515 59.5153ZM368.711 70.1459C369.176 69.5873 370.006 69.5118 370.565 69.9773L371.05 70.3817C372.112 71.2666 373.016 72.02 373.642 72.7129C374.307 73.4489 374.825 74.2953 374.825 75.3777C374.825 76.4601 374.307 77.3065 373.642 78.0425C373.016 78.7354 372.112 79.4888 371.05 80.3737L370.565 80.7781C370.006 81.2436 369.176 81.1681 368.711 80.6095C368.245 80.0509 368.321 79.2206 368.879 78.7551L369.291 78.4122C370.447 77.4487 371.203 76.8146 371.688 76.2776C372.148 75.7677 372.192 75.5286 372.192 75.3777C372.192 75.2268 372.148 74.9877 371.688 74.4778C371.203 73.9408 370.447 73.3067 369.291 72.3432L368.879 72.0003C368.321 71.5348 368.245 70.7045 368.711 70.1459ZM388.594 79.7666C388.594 80.4938 388.005 81.0833 387.278 81.0833H378.5C377.773 81.0833 377.183 80.4938 377.183 79.7666C377.183 79.0394 377.773 78.4499 378.5 78.4499H387.278C388.005 78.4499 388.594 79.0394 388.594 79.7666Z",
    fill: "#F44336"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145.5,
    y: 384,
    width: 225,
    height: 67,
    rx: 33.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.512 409.138C187.687 409.138 189.477 409.908 190.928 411.427C192.378 412.968 193.103 414.848 193.103 417.069C193.103 419.29 192.378 421.17 190.928 422.711C189.477 424.252 187.687 425 185.512 425H179.28V409.138H185.512ZM185.512 422.507C187.007 422.507 188.208 422.009 189.16 420.967C190.112 419.947 190.588 418.655 190.588 417.069C190.588 415.483 190.112 414.191 189.16 413.171C188.208 412.152 187.007 411.631 185.512 411.631H181.886V422.507H185.512ZM204.293 413.67H206.741V425H204.293V423.368C203.364 424.66 202.05 425.295 200.328 425.295C198.764 425.295 197.428 424.728 196.34 423.572C195.229 422.417 194.686 421.012 194.686 419.335C194.686 417.658 195.229 416.253 196.34 415.098C197.428 413.965 198.764 413.375 200.328 413.375C202.05 413.375 203.364 414.01 204.293 415.279V413.67ZM200.713 422.961C201.733 422.961 202.594 422.621 203.274 421.941C203.954 421.261 204.293 420.377 204.293 419.335C204.293 418.293 203.954 417.432 203.274 416.752C202.594 416.072 201.733 415.709 200.713 415.709C199.671 415.709 198.832 416.072 198.153 416.752C197.473 417.432 197.133 418.293 197.133 419.335C197.133 420.377 197.473 421.261 198.153 421.941C198.832 422.621 199.671 422.961 200.713 422.961ZM215.915 416.027H213.106V421.465C213.106 421.941 213.196 422.281 213.423 422.485C213.627 422.689 213.944 422.802 214.352 422.825C214.76 422.847 215.281 422.847 215.915 422.802V425C214.035 425.227 212.698 425.068 211.882 424.524C211.066 423.98 210.658 422.961 210.658 421.465V416.027H208.574V413.67H210.658V411.223L213.106 410.498V413.67H215.915V416.027ZM226.644 413.67H229.091V425H226.644V423.368C225.715 424.66 224.4 425.295 222.678 425.295C221.115 425.295 219.778 424.728 218.69 423.572C217.58 422.417 217.036 421.012 217.036 419.335C217.036 417.658 217.58 416.253 218.69 415.098C219.778 413.965 221.115 413.375 222.678 413.375C224.4 413.375 225.715 414.01 226.644 415.279V413.67ZM223.063 422.961C224.083 422.961 224.944 422.621 225.624 421.941C226.304 421.261 226.644 420.377 226.644 419.335C226.644 418.293 226.304 417.432 225.624 416.752C224.944 416.072 224.083 415.709 223.063 415.709C222.021 415.709 221.183 416.072 220.503 416.752C219.823 417.432 219.483 418.293 219.483 419.335C219.483 420.377 219.823 421.261 220.503 421.941C221.183 422.621 222.021 422.961 223.063 422.961Z",
    fill: "#272A39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.1 425L246.99 421.805H240.237L239.127 425H236.294L242.05 409.138H245.177L250.91 425H248.1ZM241.098 419.358H246.129L243.613 412.197L241.098 419.358ZM258.417 413.375C259.708 413.375 260.751 413.806 261.566 414.622C262.359 415.46 262.767 416.593 262.767 418.043V425H260.32V418.293C260.32 417.454 260.093 416.797 259.64 416.344C259.187 415.891 258.553 415.664 257.782 415.664C256.921 415.664 256.219 415.936 255.697 416.48C255.154 417.024 254.904 417.839 254.904 418.927V425H252.457V413.67H254.904V415.12C255.629 413.965 256.808 413.375 258.417 413.375ZM274.376 413.67H276.823V425H274.376V423.368C273.447 424.66 272.132 425.295 270.41 425.295C268.847 425.295 267.51 424.728 266.422 423.572C265.312 422.417 264.768 421.012 264.768 419.335C264.768 417.658 265.312 416.253 266.422 415.098C267.51 413.965 268.847 413.375 270.41 413.375C272.132 413.375 273.447 414.01 274.376 415.279V413.67ZM270.795 422.961C271.815 422.961 272.676 422.621 273.356 421.941C274.036 421.261 274.376 420.377 274.376 419.335C274.376 418.293 274.036 417.432 273.356 416.752C272.676 416.072 271.815 415.709 270.795 415.709C269.753 415.709 268.915 416.072 268.235 416.752C267.555 417.432 267.215 418.293 267.215 419.335C267.215 420.377 267.555 421.261 268.235 421.941C268.915 422.621 269.753 422.961 270.795 422.961ZM279.676 425V408.458H282.123V425H279.676ZM292.601 413.67H295.207L290.856 425.363C289.768 428.308 287.91 429.691 285.327 429.532V427.243C286.097 427.289 286.709 427.13 287.185 426.767C287.638 426.405 288.023 425.816 288.341 425.023L288.454 424.796L283.65 413.67H286.324L289.7 421.896L292.601 413.67ZM299.439 422.689H304.945V425H296.108V423.368L301.41 415.981H296.334V413.67H304.719V415.302L299.439 422.689ZM308.45 411.97C308.019 411.97 307.657 411.835 307.339 411.517C307.022 411.2 306.886 410.838 306.886 410.407C306.886 409.999 307.022 409.637 307.339 409.319C307.634 409.002 307.996 408.843 308.45 408.843C308.88 408.843 309.243 409.002 309.56 409.319C309.855 409.637 310.013 409.999 310.013 410.407C310.013 410.838 309.855 411.2 309.537 411.517C309.22 411.835 308.858 411.97 308.45 411.97ZM307.226 425V413.67H309.673V425H307.226ZM318.474 413.375C319.766 413.375 320.808 413.806 321.624 414.622C322.417 415.46 322.825 416.593 322.825 418.043V425H320.378V418.293C320.378 417.454 320.151 416.797 319.698 416.344C319.245 415.891 318.61 415.664 317.84 415.664C316.979 415.664 316.276 415.936 315.755 416.48C315.211 417.024 314.962 417.839 314.962 418.927V425H312.515V413.67H314.962V415.12C315.687 413.965 316.866 413.375 318.474 413.375ZM334.479 413.67H336.881V424.479C336.881 426.201 336.314 427.538 335.181 428.444C334.048 429.373 332.666 429.827 331.057 429.827C328.429 429.827 326.639 428.92 325.687 427.085L327.794 425.861C328.383 427.039 329.471 427.606 331.103 427.606C332.145 427.606 332.983 427.334 333.573 426.79C334.162 426.246 334.479 425.476 334.479 424.479V423.097C333.55 424.411 332.236 425.068 330.536 425.068C328.927 425.068 327.568 424.501 326.48 423.368C325.37 422.235 324.826 420.853 324.826 419.222C324.826 417.613 325.37 416.231 326.48 415.098C327.568 413.965 328.927 413.375 330.536 413.375C332.236 413.375 333.55 414.033 334.479 415.347V413.67ZM330.876 422.779C331.896 422.779 332.757 422.439 333.437 421.76C334.116 421.08 334.479 420.241 334.479 419.222C334.479 418.225 334.116 417.364 333.437 416.684C332.757 416.004 331.896 415.664 330.876 415.664C329.834 415.664 328.973 416.004 328.293 416.684C327.613 417.364 327.273 418.225 327.273 419.222C327.273 420.241 327.613 421.08 328.293 421.76C328.973 422.439 329.834 422.779 330.876 422.779Z",
    fill: "#F44336"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 281,
    width: 66,
    height: 66,
    rx: 33,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.01 303.064C449.665 304.195 451.311 305.556 452.877 307.123C454.444 308.689 455.805 310.335 456.936 311.99C457.9 310.096 458.48 308.303 458.659 306.747C458.885 304.784 458.469 303.335 457.567 302.433C456.666 301.532 455.216 301.115 453.254 301.341C451.698 301.521 449.904 302.1 448.01 303.064ZM458.195 314C459.577 311.573 460.457 309.155 460.708 306.983C460.976 304.659 460.531 302.48 459.025 300.975C457.52 299.469 455.341 299.024 453.017 299.292C450.845 299.543 448.427 300.423 446 301.805C443.573 300.423 441.156 299.543 438.984 299.292C436.66 299.024 434.481 299.47 432.976 300.975C431.47 302.48 431.025 304.659 431.293 306.983C431.544 309.155 432.424 311.573 433.806 314C432.424 316.427 431.544 318.844 431.293 321.016C431.025 323.34 431.471 325.519 432.976 327.024C434.481 328.53 436.66 328.975 438.984 328.707C441.156 328.456 443.573 327.576 446 326.194C448.427 327.576 450.845 328.456 453.017 328.707C455.341 328.975 457.52 328.53 459.025 327.024C460.531 325.519 460.976 323.341 460.708 321.016C460.457 318.844 459.577 316.427 458.195 314ZM455.79 314C454.639 312.178 453.17 310.332 451.419 308.581C449.668 306.83 447.822 305.361 446 304.211C444.179 305.361 442.333 306.83 440.582 308.581C438.831 310.332 437.362 312.178 436.211 314C437.362 315.822 438.831 317.667 440.582 319.418C442.333 321.169 444.178 322.638 446 323.789C447.823 322.638 449.668 321.169 451.419 319.418C453.17 317.667 454.639 315.822 455.79 314ZM448.01 324.935C449.665 323.804 451.311 322.443 452.878 320.877C454.444 319.31 455.805 317.664 456.936 316.01C457.9 317.904 458.479 319.697 458.659 321.253C458.885 323.215 458.468 324.665 457.567 325.566C456.665 326.468 455.216 326.884 453.253 326.658C451.698 326.479 449.904 325.899 448.01 324.935ZM443.991 324.935C442.336 323.804 440.69 322.443 439.123 320.877C437.557 319.31 436.196 317.664 435.065 316.01C434.101 317.904 433.522 319.697 433.342 321.253C433.116 323.215 433.533 324.664 434.434 325.566C435.336 326.467 436.786 326.884 438.748 326.658C440.303 326.478 442.097 325.899 443.991 324.935ZM435.065 311.99C436.196 310.335 437.557 308.689 439.124 307.123C440.69 305.556 442.336 304.195 443.991 303.064C442.097 302.1 440.303 301.521 438.747 301.341C436.785 301.115 435.336 301.532 434.434 302.433C433.533 303.335 433.116 304.785 433.342 306.747C433.522 308.303 434.101 310.096 435.065 311.99ZM446.001 311.593C444.672 311.593 443.594 312.671 443.594 314C443.594 315.329 444.672 316.406 446.001 316.406C447.33 316.406 448.407 315.329 448.407 314C448.407 312.671 447.33 311.593 446.001 311.593ZM441.532 314C441.532 311.532 443.533 309.531 446.001 309.531C448.469 309.531 450.469 311.532 450.469 314C450.469 316.468 448.469 318.468 446.001 318.468C443.533 318.468 441.532 316.468 441.532 314Z",
    fill: "#009D81"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_356_3681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 293,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4855 316.794L76.6306 322.647L75.7495 321.772C74.6983 320.728 74.4781 320.568 73.7493 320.319C72.909 320.033 72.0155 320.027 71.2112 320.303C70.5908 320.516 70.1602 320.822 69.231 321.712C68.9722 321.96 66.7923 323.681 63.4282 326.294C58.2387 330.325 56.9404 331.348 56.9404 331.406C56.9404 331.421 59.7825 334.274 63.2561 337.747L69.5717 344.06L69.8588 343.714C70.2951 343.188 70.5911 342.817 71.2264 342C71.5456 341.59 72.5337 340.322 73.4221 339.182C74.3105 338.043 75.5679 336.429 76.2163 335.598C78.6777 332.439 78.5453 332.599 79.3661 331.808C79.7879 331.401 80.2055 330.964 80.294 330.836C80.92 329.933 81.1484 328.714 80.8851 327.682C80.6611 326.805 80.4395 326.478 79.255 325.277L78.3336 324.343L84.1971 318.481L90.0604 312.619L89.2216 311.78C88.7602 311.318 88.3732 310.94 88.3616 310.94C88.3499 310.94 85.7057 313.574 82.4855 316.794ZM73.1525 322.616C73.3886 322.733 73.6936 323.024 75.9307 325.267C78.7787 328.122 78.5992 327.898 78.5992 328.594C78.5992 328.951 78.5868 329.014 78.4672 329.266C78.3366 329.542 77.9917 329.962 77.8958 329.962C77.8585 329.962 72.2632 324.405 71.2639 323.375L71.0997 323.206L71.3261 322.976C71.7419 322.554 71.9745 322.455 72.51 322.472C72.8355 322.483 72.9236 322.503 73.1525 322.616ZM72.7887 328.214L76.2632 331.688L75.7291 332.368C75.4353 332.743 74.7495 333.618 74.205 334.313C73.6606 335.008 72.9885 335.866 72.7114 336.219C72.4344 336.572 71.7261 337.477 71.1374 338.229C70.5487 338.981 69.9078 339.798 69.7132 340.044L69.3594 340.491L68.5187 339.651L67.6779 338.811L67.8161 338.665C67.8921 338.585 68.4615 337.989 69.0814 337.342L70.2085 336.165L69.5539 335.538C69.194 335.192 68.813 334.831 68.7074 334.735L68.5155 334.56L67.6504 335.461C67.1746 335.957 66.6134 336.54 66.4032 336.757L66.0211 337.152L65.2541 336.385L64.487 335.618L66.7428 333.339C67.9836 332.085 68.9997 331.048 69.0009 331.034C69.002 331.019 68.6377 330.641 68.1912 330.193L67.3794 329.378L65.1014 331.638C63.8485 332.881 62.8101 333.899 62.7937 333.899C62.7773 333.899 62.251 333.385 61.6242 332.757C60.4923 331.624 60.4852 331.616 60.5746 331.545C60.6242 331.506 60.9972 331.214 61.4037 330.897C61.8101 330.579 62.3106 330.186 62.5158 330.024C62.7209 329.862 63.4484 329.291 64.1324 328.756C64.8164 328.22 65.8983 327.373 66.5366 326.873C68.6183 325.241 69.2653 324.74 69.2899 324.74C69.3032 324.74 70.8777 326.303 72.7887 328.214Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_356_3681",
    x: 339.333,
    y: 121.833,
    width: 130.333,
    height: 130.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.83333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.5,
    dy: 17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.6667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_356_3681",
    x: 347.333,
    y: 321.333,
    width: 61.3333,
    height: 61.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_356_3681",
    x: 101.667,
    y: 298.667,
    width: 122.667,
    height: 122.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.66667,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.3333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_356_3681",
    x: 75.3333,
    y: 95.3333,
    width: 153.333,
    height: 153.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.6667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_356_3681",
    x: 115.12,
    y: 15.88,
    width: 113.28,
    height: 113.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.92,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.76,
    dy: 11.52
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_356_3681",
    x: 294.76,
    y: 0.240006,
    width: 186.44,
    height: 186.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.16,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.48,
    dy: 18.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_356_3681",
    x: 376.04,
    y: 251.96,
    width: 155.76,
    height: 155.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.64,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.92,
    dy: 15.84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_356_3681",
    x: 0.359997,
    y: 262.64,
    width: 162.84,
    height: 162.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.76,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.28,
    dy: 16.56
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.08
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3681",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3);
export default __webpack_public_path__ + "static/media/circle-3.4cf44a36266bcc5c6c9b07334fd324cf.svg";
export { ForwardRef as ReactComponent };